module.exports = require('iserror')



// WEBPACK FOOTER //
// ../core/lib/iserror.js